import { useQuery } from "@tanstack/react-query"

import { getDashboardSummary } from "@/features/dashboard/api/dashboard.api"

export const dashboardKeys = {
  all: ["dashboard"] as const,
  summary: () => ["dashboard", "summary"] as const,
}

export function useDashboardSummary() {
  return useQuery({
    queryKey: dashboardKeys.summary(),
    queryFn: getDashboardSummary,
    staleTime: 30_000,
  })
}
